import React from 'react';

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  selectedStatus: string;
  onStatusChange: (status: string) => void;
}

/**
 * SearchBar Component
 * Provides text search and status filtering for tasks
 * 
 * @param searchQuery - Current search text
 * @param onSearchChange - Handler for search text changes
 * @param selectedStatus - Currently selected status filter
 * @param onStatusChange - Handler for status filter changes
 */
export const SearchBar: React.FC<SearchBarProps> = ({
  searchQuery,
  onSearchChange,
  selectedStatus,
  onStatusChange,
}) => {
  return (
    <div className="search-bar">
      <input
        type="text"
        placeholder="Search tasks..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className="search-input"
        aria-label="Search tasks"
      />

      <select
        value={selectedStatus}
        onChange={(e) => onStatusChange(e.target.value)}
        className="status-filter"
        aria-label="Filter by status"
      >
        <option value="ALL">All Statuses</option>
        <option value="TODO">TODO</option>
        <option value="IN_PROGRESS">In Progress</option>
        <option value="DONE">Done</option>
      </select>
    </div>
  );
};
